import SkillSet from './skillSet';
import TimelineData from './timelineData';

const Constants = {
    SkillSet,
    TimelineData,
};

export default Constants;
